import { getJSON, putJSON } from "../../../shared_component/utils/fetch"

export const CARADVISE_RECOMMENDED_URL = "/api/v4/services/recommended/caradvise"

export const CARADVISE_RECOMMENDED_SERVICES = "CARADVISE_RECOMMENDED_SERVICES"
const MARK_SERVICES_COMPLETED_URL = "/api/v4/service_based_reminders"
function caradviseRecommendedServices(data) {
  return { type: CARADVISE_RECOMMENDED_SERVICES, payload: data }
}

export function fetchCarAdviseRecemendedServices(data) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const { authentication_token } = user
    const url = CARADVISE_RECOMMENDED_URL

    try {
      const headers = { Authorization: authentication_token }
      const response = await getJSON(url, data, headers)
      if (response.result) {
        return response
      } else {
        const error = response.error || response.errors
        return error
      }
    } catch (e) {
      return e
    }
  }
}

export function markServicesCompletedAPI(data) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const { authentication_token } = user
    const url = `${MARK_SERVICES_COMPLETED_URL}/${data.vehicle_id}`
    const body = {
      ...data,
      customer_id: user.id
    }

    try {
      const headers = { Authorization: authentication_token }
      const response = await putJSON(url, body, headers)
      if (response.result) {
        return response
      } else {
        const error = response.error || response.errors
        return error
      }
    } catch (e) {
      return e
    }
  }
}
